import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e46f40a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "tableContainer" }
const _hoisted_2 = { class: "control-block" }
const _hoisted_3 = { class: "select-block" }
const _hoisted_4 = { class: "search-block" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span" }, "工单号:", -1))
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span type" }, "类型:", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_10 = { class: "block" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span" }, "创建时间:", -1))
const _hoisted_12 = { class: "block" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_14 = { class: "checkBox-block" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "i" }
const _hoisted_17 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_18 = ["xlink:href"]
const _hoisted_19 = { class: "text" }
const _hoisted_20 = {
  class: "table-block1",
  ref: "table"
}
const _hoisted_21 = { class: "op" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_RangePicker = _resolveComponent("RangePicker")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ParticularsModal = _resolveComponent("ParticularsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_Input, {
              value: _ctx.customId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customId) = $event)),
              width: "1.6rem",
              placeholder: "请输入工单号"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Select, {
              value: _ctx.orderType,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderType) = $event)),
              placeholder: "请选择工单类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Option, { value: -1 }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grantTicktTypeList, (i, index) => {
                  return (_openBlock(), _createBlock(_component_Option, {
                    key: index,
                    value: i.key
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(i.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
              default: _withCtx(() => [
                _createVNode(_component_RangePicker, {
                  format: "YYYY-MM-DD",
                  value: _ctx.customDate,
                  onChange: _ctx.onChange
                }, null, 8, ["value", "onChange"])
              ]),
              _: 1
            }, 8, ["locale"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Button, {
              type: "primary",
              onClick: _ctx.search
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkBox, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.title,
              class: _normalizeClass(['block', item.seleted ? 'active' : '']),
              onClick: ($event: any) => (_ctx.changeBox(idx))
            }, [
              _createElementVNode("span", _hoisted_16, [
                _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_17, [
                  _createElementVNode("use", {
                    "xlink:href": `#${item.seleted?item.iconfont:'icon-zhihui'}`
                  }, null, 8, _hoisted_18)
                ], 512)), [
                  [_vShow, item.iconfont]
                ])
              ]),
              _createElementVNode("span", _hoisted_19, _toDisplayString(item.title), 1)
            ], 10, _hoisted_15))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_Table, {
        columns: _ctx.columns,
        "data-source": _ctx.tableData,
        customRow: _ctx.rowClick,
        customHeaderRow: _ctx.rowClick,
        onChange: _ctx.onTableChange,
        scroll: { y: _ctx.isfull ?
        '100%'
        :_ctx.y },
        pagination: {
            total:_ctx.total,
            pageSize:10,
            size:'small',
            current:_ctx.current,
            onChange:_ctx.paginationChange,
          }
      }, {
        index: _withCtx(({ index,}) => [
          _createTextVNode(_toDisplayString(index + 1), 1)
        ]),
        type: _withCtx(({ text }) => [
          _createTextVNode(_toDisplayString(_ctx.allTicketTypeList[text - 1]?.label || ''), 1)
        ]),
        orderType: _withCtx(({ text }) => [
          _createTextVNode(_toDisplayString(_ctx.orderTypeList[text]), 1)
        ]),
        status: _withCtx(({ text }) => [
          _createTextVNode(_toDisplayString(_ctx.ticketStatus[text-1].title), 1)
        ]),
        acceptProcess: _withCtx(({ text }) => [
          _createTextVNode(_toDisplayString(text ? text : '--'), 1)
        ]),
        op: _withCtx(({ record }) => [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_Button, {
              onClick: ($event: any) => (_ctx.showParticularsModal(record,''))
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "customRow", "customHeaderRow", "onChange", "scroll", "pagination"])
    ], 512),
    _createVNode(_component_ParticularsModal, {
      particularsVisible: _ctx.particularsVisible,
      "onUpdate:particularsVisible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.particularsVisible) = $event)),
      ref: "particularsModalRef",
      selectOrderCode: _ctx.selectOrderCode,
      action: _ctx.action,
      class: "position:absolute"
    }, null, 8, ["particularsVisible", "selectOrderCode", "action"])
  ]))
}